<template>
  <RevLoadingScreen
    v-if="status === 'pending'"
    class="py-72"
    :text="i18n(translations.loading)"
    variant="light"
  />

  <div v-if="status !== 'pending' && orderDetails">
    <div class="gap-16 md:grid md:grid-cols-2">
      <Contact class="md:col-span-2" :order />
      <OrderStatus class="md:col-span-2" :orderDetails />
      <OrderDetails :orderDetails />
      <ShippingDetails :orderDetails />
      <OrderLinesItems class="md:col-span-2" :orderDetails />
      <Address
        :address-info="orderDetails.deliveryAddress"
        :email="orderDetails.shippingEmail"
        :title="i18n(translations.shippingAddress)"
      />
      <Address
        :address-info="orderDetails.billingAddress"
        :email="orderDetails.invoiceEmail"
        :fiscal-identification-number="orderDetails.fiscalIdentificationNumber"
        :title="i18n(translations.billingAddress)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { getMerchantOrdersDetails } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants-orders/merchant-orders-page'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'

import type { Order } from '../../../../../../../../../../Tab.types'

import translations from './OrderDetails.translations'
import Address from './components/Address/Address.vue'
import Contact from './components/Contact/Contact.vue'
import OrderDetails from './components/OrderDetails/OrderDetails.vue'
import OrderLinesItems from './components/OrderLinesItems/OrderLinesItems.vue'
import OrderStatus from './components/OrderStatus/OrderStatus.vue'
import ShippingDetails from './components/ShippingDetails/ShippingDetails.vue'

const props = defineProps<{ order: Order }>()
const i18n = useI18n()

const { data: orderDetails, status } = useHttpFetch(getMerchantOrdersDetails, {
  pathParams: {
    orderId: props.order.id,
  },
})
</script>
